function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-9cb45400-fcda-4524-9fdb-679299dec099",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.521,19.369v-.401c0-2.234,1.082-3.718,3.352-5.08,2.112-1.274,2.863-2.321,2.863-4.032,0-2.06-1.589-3.474-3.91-3.474-2.112,0-3.509,1.047-4.067,2.95-.349,1.082-.89,1.466-1.763,1.466-1.082,0-1.693-.646-1.693-1.71,0-.75.157-1.362.471-2.042,1.065-2.409,3.718-3.875,7.209-3.875,4.556,0,7.716,2.671,7.716,6.528,0,2.706-1.362,4.556-3.666,5.935-2.252,1.327-2.845,2.217-2.933,3.928-.087,1.117-.611,1.85-1.746,1.85-1.222,0-1.833-.89-1.833-2.042Zm-.454,7.209c0-1.274,1.012-2.251,2.287-2.251,1.309,0,2.304.978,2.304,2.251s-.995,2.252-2.304,2.252c-1.274,0-2.287-.978-2.287-2.252Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.6077df1954a0e5dcd3c8641f2322fbb0.svg";
export { ForwardRef as ReactComponent };